<template>
  <router-view/>
</template>

<script>
export default {
  name: 'app',
  created () {
    Array.prototype.max = function () {
      var input = this
      return Math.max.apply(Math, input)
    }
    Array.prototype.min = function () {
      var input = this
      return Math.min.apply(Math, input)
    }
    Array.prototype.shuffle = function () {
      var input = this
      for (var i = input.length - 1; i >= 0; i--) {
        var randomIndex = Math.floor(Math.random() * (i + 1))
        var itemAtIndex = input[randomIndex]
        input[randomIndex] = input[i]
        input[i] = itemAtIndex
      }
      return input
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue